export const exposureFactorTable = [
  {
    rentingDays: {
      from: 1,
    },
    factorDeExposicion: 0.04,
  },
  {
    rentingDays: {
      from: 2,
    },
    factorDeExposicion: 0.06,
  },
  {
    rentingDays: {
      from: 3,
    },
    factorDeExposicion: 0.08,
  },
  {
    rentingDays: {
      from: 4,
    },
    factorDeExposicion: 0.09,
  },
  {
    rentingDays: {
      from: 5,
    },
    factorDeExposicion: 0.1,
  },
  {
    rentingDays: {
      from: 6,
    },
    factorDeExposicion: 0.11,
  },
  {
    rentingDays: {
      from: 7,
    },
    factorDeExposicion: 0.12,
  },
  {
    rentingDays: {
      from: 8,
      to: 14,
    },
    factorDeExposicion: 0.17,
  },
  {
    rentingDays: {
      from: 15,
      to: 21,
    },
    factorDeExposicion: 0.21,
  },
  {
    rentingDays: {
      from: 22,
      to: 30,
    },
    factorDeExposicion: 0.26,
  },
  {
    rentingDays: {
      from: 31,
      to: 60,
    },
    factorDeExposicion: 0.38,
  },
  {
    rentingDays: {
      from: 61,
      to: 90,
    },
    factorDeExposicion: 0.47,
  },
  {
    rentingDays: {
      from: 91,
      to: 120,
    },
    factorDeExposicion: 0.55,
  },
  {
    rentingDays: {
      from: 121,
      to: 210,
    },
    factorDeExposicion: 0.74,
  },
  {
    rentingDays: {
      from: 211,
      to: 365,
    },
    factorDeExposicion: 1,
  },
];
export const tablaDeFactorTipoMaterial = [
  {
    Tipo: 'CAMARAS',
    Subtipo: 'CÁMARAS',
    factorDanosMateriales: 1.05,
    FactorRoboYExpoliacion: 1.1,
  },
  {
    Tipo: 'OPTICAS',
    Subtipo: 'OPTICAS',
    factorDanosMateriales: 1.05,
    FactorRoboYExpoliacion: 1.1,
  },
  {
    Tipo: 'MONITORES',
    Subtipo: 'MONITORES',
    factorDanosMateriales: 1.1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'MANDOS DE FOCO',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'VIDEOTRANSMISORES',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'INTERCOMUNICADORES',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'ACCESORIOS DE CAMARA',
    Descripcion: 'Trı́podes de cá́mara',
    factorDanosMateriales: 1.05,
    FactorRoboYExpoliacion: 1.1,
  },
  {
    Tipo: 'SOPORTES CÁMARAS',
    Subtipo: 'ESTABILIZACION',
    factorDanosMateriales: 1.05,
    FactorRoboYExpoliacion: 1.1,
  },
  {
    Tipo: 'DRONES',
    Subtipo: 'FILMACION ESPECIAL',
    factorDanosMateriales: 1.05,
    FactorRoboYExpoliacion: 1.05,
  },
  {
    Tipo: 'GRIP',
    Subtipo: 'GRIP',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'EFECTOS',
    Subtipo: 'EFECTOS Y EQUIPAMIENTO',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'ENERGÍA',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'MATERIAL PRODUCCIÓN',
    Subtipo: 'MATERIAL PRODUCCIÓN',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
  {
    Tipo: 'ACCESORIOS',
    Subtipo: 'ACCESORIOS DE OPTICAS',
    factorDanosMateriales: 1,
    FactorRoboYExpoliacion: 1,
  },
];
